import {gql} from 'apollo-boost';

export const removeProductMutation = gql`
    mutation removeProduct($id: Int!) {
        removeProduct(id: $id)
    }
`;
